import { useQuery, gql } from '@apollo/client';
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { IsLoggedInQuery } from '../generated/graphql';

export const IS_USER_LOGGED_IN = gql`
  query isLoggedIn {
    isLoggedIn {
      loggedIn
      user
    }
  }
`;

export const PrivateRoute = ({
  children,
  user,
  redirect,
}: {
  children: React.ReactNode;
  user: string;
  redirect: string;
}): JSX.Element | null => {
  const { loading, data } = useQuery<IsLoggedInQuery>(IS_USER_LOGGED_IN);

  if (loading) return null;

  return (
    <>
      {(data?.isLoggedIn?.loggedIn && data.isLoggedIn.user === user) ||
      (data?.isLoggedIn?.loggedIn && data.isLoggedIn.user === 'sub-admin') ? (
        children
      ) : (
        <Navigate to={redirect} />
      )}
    </>
  );
};
